import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useRef } from 'react' 

type ModalProps = {
  show : boolean
  title?: String
  body?: String
  children?: JSX.Element
  cancelText?: String
  okText?: String
  okAction?: () => void
  cancelAction?: () => void
  onHide: () => void
  okClass?: string,
  okMoreStyles?: String,
  loading?: boolean,
  fullWidth?: boolean,
  isDisabled?: boolean,
  maxWidth?: String
}

const ModalConfirmNew = ({ 
  show = false, 
  title = '',
  body = '',
  children,
  cancelText = '',
  okText = '',
  okAction,
  onHide,
  okClass,
  cancelAction,
  okMoreStyles = '',
  loading = false,
  fullWidth = false,
  isDisabled = false,
  maxWidth = 'max-w-md'
} : ModalProps) => {

  let completeButtonRef = useRef(null)
  
  function closeModal() {
    onHide()
  }

  let okStyle = 'justify-center px-4 py-2 text-md font-medium text-white bg-blue-500 rounded hover:bg-blue-600'
  if (okClass) {
    okStyle = okClass
  }
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog
        initialFocus={completeButtonRef}
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={closeModal}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 transition-opacity bg-black bg-opacity-30" />
          </Transition.Child>
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className={`inline-block w-full ${fullWidth ? '': maxWidth} p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-xl`}>
              <div className="mt-2">
                {body ? <p className="text-gray-500 text-md">{body}</p> : null}
                {children}
              </div>
              <div className="mt-5 text-center">
                <button
                  type="button"
                  className={`${cancelText ? 'inline-flex' : 'hidden'} mr-3 justify-center px-7 py-2 text-md font-medium text-gray-500 border border-gray-300 rounded bg-gray-300 hover:bg-gray-400`}
                  onClick={cancelAction ? cancelAction : closeModal}
                >
                  {cancelText}
                </button>
                <button
                  type="button"
                  className={`${okText ? 'inline-flex' : 'hidden'} ${okStyle} ${okMoreStyles}`}
                  onClick={okAction}
                  disabled={loading || isDisabled}
                  ref={completeButtonRef}
                >
                  {loading ? `${okText}ing...`: okText}
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export default ModalConfirmNew